export const approaches = ['RNAV', 'ILS', 'VOR', 'NDB', 'LOC', 'RADAR']
